import { render } from "./SimpleDate.vue?vue&type=template&id=03a8a72b&scoped=true"
import script from "./SimpleDate.vue?vue&type=script&lang=js"
export * from "./SimpleDate.vue?vue&type=script&lang=js"

import "./SimpleDate.vue?vue&type=style&index=0&id=03a8a72b&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a8a72b"]])

export default __exports__